import React from 'react';
import {asQueryParam, ParentCaseListFilterValue} from "./ParentCaseListFilter";
import {ParentCaseListAction} from "./parentCaseListReducer";
import {SPLIT_DELIMITER} from "../../placement/const";
import CancelIcon from "@material-ui/icons/Cancel";
import {formatDate} from "../../common/util/date";
import {ParentCaseServiceTypeNameToValue, ParentCaseServiceTypeValueToName} from "./domain";


type ParentCaseListFilterBadgeProps = {
    filter: ParentCaseListFilterValue
    dispatch: React.Dispatch<ParentCaseListAction>
}

export function ParentCaseListFilterBadge({filter, dispatch}: ParentCaseListFilterBadgeProps) {
    let values: Array<string> = [];

    if (filter.fromDate !== null) {
        values = values.concat(`Placement date from: ${formatDate(filter.fromDate!)}`);
    }
    if (filter.toDate !== null) {
        values = values.concat(`Placement date to: ${formatDate(filter.toDate!)}`);
    }

    if (filter.cpaStatus !== "") {
        values = values.concat(`Status: ${filter.cpaStatus}`);
    }
    if (filter.serviceType) {
        values = values.concat(filter.serviceType.split(SPLIT_DELIMITER).filter((serviceType) => serviceType !== ""));
    }

    const params = asQueryParam(filter);
    values = values.concat(params.cities);

    const updateFilterByRemoveValue = (value: string) => {
        if (value) {
            value = ParentCaseServiceTypeValueToName.get(value) ? ParentCaseServiceTypeValueToName.get(value)! : value;

            if (value.includes("Placement date from:")) {
                dispatch({type: 'SET_FILTER', filter: {...filter, fromDate: null}});
                return;
            }

            if (value.includes("Placement date to:")) {
                dispatch({type: 'SET_FILTER', filter: {...filter, toDate: null}});
                return;
            }

            if (value.includes("Status:")) {
                dispatch({type: 'SET_FILTER', filter: {...filter, cpaStatus: ""}});
                return;
            }

            const keyArr = [
                "cities",
                "serviceType",
            ];
            for (let i = 0; i < keyArr.length; i++) {
                const key = keyArr[i] as "cities" | "serviceType";
                const filterOptions = (filter[key] as string).split(SPLIT_DELIMITER);
                if (filterOptions.includes(value)) {
                    const newOptions = filterOptions.filter((val) => val !== value).join(SPLIT_DELIMITER);
                    const newFilter = {...filter};
                    newFilter[key] = newOptions;
                    dispatch({type: 'SET_FILTER', filter: newFilter});
                    return
                }
            }
        }
    }

    if (values.length === 0) {
        return <div/>;
    }

    return (
        <div className='flex pl-5 items-start'>
            <div className='pt-2 pr-5 flex-grow-0'>
                Filter:
            </div>
            <div className='flex flex-grow flex-wrap'>
                {
                    values.map((value) => (
                        <div key={value}
                             className='mr-2 mb-2 bg-botticelli-100 text-white p-2 rounded leading-none flex items-center'>
                            {ParentCaseServiceTypeNameToValue.get(value) ? ParentCaseServiceTypeNameToValue.get(value) : value}
                            <button className='bg-transparent outline-none focus:outline-none'
                                    onClick={() => updateFilterByRemoveValue(value)}>
                                <div
                                    className='bg-transparent text-white opacity-5 ml-3 outline-none focus:outline-none flex items-center'>
                                    <CancelIcon fontSize={"small"}/>
                                </div>
                            </button>
                        </div>
                    ))
                }
            </div>
        </div>);
}


